import { Input, Slider } from '@heroui/react'
import { Controller } from 'react-hook-form'

export function SliderPx({ control, field, label, min = 0, max = 100 }) {
  return (
    <Controller
      control={control}
      name={field}
      render={({ field }) => (
        <Slider
          label={label}
          size="sm"
          value={field.value}
          onChange={val => field.onChange(val)}
          minValue={min}
          maxValue={max}
          className="w-full"
          renderValue={() => (
            <div className="flex items-center gap-2">
              <Input
                type="number"
                size="sm"
                min={min}
                max={max}
                className="w-20"
                variant="bordered"
                value={field.value}
                onChange={e => field.onChange(Number(e.target.value))}
              />
              <span className="text-xs text-gray-500">px</span>
            </div>
          )}
        />
      )}
    />
  )
}
